import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  InputGroup,
  Overlay,
  Tooltip,
  FormControl,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import PagingNav from "../component/PagingNav";
import { getUserSession } from "../component/userInfo";
import Image from "react-bootstrap/Image";
import { useLocation, useParams } from "react-router";

import "./MybbsAdmin.css";

const MybbsMaster = () => {
  const params = useParams();
  const location = useLocation();

  const [paging, setPaging] = useState();
  const [list, setList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [mybbsMasterId, setMybbsMasterId] = useState("archive");
  const [mybbsMasterTitle, setMybbsMasterTitle] =
    useState("나눔방(게시판)관리");

  // --- 조회 기능용 상태 변수 추가 ---
  const [perpage, setPerpage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [tempKeyword, setTempKeyword] = useState("");

  useEffect(() => {
    setMybbsMasterId(params.mybbsMasterId);
    fetchList(1);
  }, [keyword, perpage]);

  const fetchList = async (page) => {
    const userSession = getUserSession();
    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "boardList");
      formData.append("perpage", perpage); // 페이지 당 항목 수
      if (page) formData.append("page", page);
      if (keyword) formData.append("keyword", keyword); // 검색어
      let res = await fetch(
        "https://work.wekoinonia.org/json/mybbsMaster.php",
        {
          method: "POST",
          body: formData,
          //headers: new Headers({
          //'Content-Type': 'application/json'
          //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      );

      let json = await res.json(); //Promise 반환
      console.log(json); // 서버에서 주는 json데이터가 출력 됨
      if (json.paging) {
        setPaging(json.paging);
      }
      if (json.list) {
        setList(json.list);
      } else {
        setList([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getPage = (page) => {
    console.log("page = ", page);
    fetchList(page);
  };

  // --- 조회 핸들러 함수 추가 ---
  const handleSearch = () => {
    if (keyword !== tempKeyword) {
      setKeyword(tempKeyword);
    }
  };

  const handlePerpageChange = (e) => {
    setPerpage(parseInt(e.target.value, 10));
  };

  const selectItem = ({ target }) => {
    console.log(target);
    console.log(target.checked, target.value);

    if (target.checked) {
      let newSelectedList = selectedList.concat(target.value);
      setSelectedList(newSelectedList);
      console.log(selectedList);
    } else {
      let newSelectedList = selectedList.filter(
        (selected) => selected !== target.value
      );
      console.log(newSelectedList);
      setSelectedList(newSelectedList);
      console.log(selectedList);
    }
  };
  return (
    <div id="content">
      {" "}
      {/* https://startbootstrap.com/previews/sb-admin 참조*/}
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Page Heading */}
        <h1 className="h3 mb-2 text-gray-800">{mybbsMasterTitle}</h1>
        <p className="mb-4"></p>

        {/* DataTales Example */}
        <div className="card shadow mb-4">
          <div className="card-body">
            <div>
              {/* className="table-responsive" 이게 하단 스크롤바가 생기게 만들어서 */}
              <div
                id="dataTable_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="dataTable-top">
                  <div className="dataTable-dropdown">
                    <label>
                      <select
                        className="dataTable-selector"
                        value={perpage}
                        onChange={handlePerpageChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="25">25</option>
                      </select>
                    </label>
                  </div>
                  <div className="dataTable-search">
                    <InputGroup>
                      <FormControl
                        className="dataTable-input"
                        placeholder="제목, 내용으로 조회"
                        value={tempKeyword}
                        onChange={(e) => setTempKeyword(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      />
                      <Button variant="primary" onClick={handleSearch}>
                        조회
                      </Button>
                    </InputGroup>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <table
                      className="table table-bordered dataTable"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                      role="grid"
                      aria-describedby="dataTable_info"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr role="row">
                          {/* <th className="sorting sorting_asc" tabIndex="0" aria-controls="dataTable" rowSpan="1" colSpan="1" aria-sort="ascending" style={{width: '2rem'}}></th> */}
                          <th
                            className="sorting sorting_asc"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-sort="ascending"
                            aria-label="No"
                            style={{ width: "2rem" }}
                          >
                            No
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label="테이블이름으로정렬"
                            style={{ width: "6rem" }}
                          >
                            테이블
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label="제목: activate to sort column ascending"
                            style={{ width: "auto" }}
                          >
                            제목(게시물목록바로가기)
                          </th>
                          <th
                            className="sorting sorting_asc"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-sort="ascending"
                            aria-label="tablename"
                          >
                            물리테이블
                          </th>
                          <th
                            className="sorting sorting_asc"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-sort="ascending"
                            aria-label="memo"
                          >
                            메모
                          </th>
                          <th
                            className="sorting sorting_asc"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-sort="ascending"
                            aria-label=""
                          >
                            {/* 정보수정*/}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item, index) => {
                          //console.log(item);
                          return (
                            <tr key={index}>
                              {/* <td><Form.Check aria-label={`option ${item.tno}`} value={item.tno} onChange={e => selectItem(e)}/></td> */}
                              <td>{item.tno}</td>
                              {/* <td>{item.tindex}</td> */}
                              <td>{item.tname}</td>
                              <td>
                                <Link
                                  to={`/MybbsAdmin/${item.tname}`}
                                  state={{ item: item }}
                                >
                                  {item.title}
                                </Link>
                              </td>
                              <td>{item.tablename}</td>
                              <td>{item.description}</td>
                              <td>
                                <Link to={`/MybbsMasterForm?db=${item.tname}`}>
                                  <Button
                                    variant="primary"
                                    type="button"
                                    style={{ width: "8rem", display: "none" }}
                                  >
                                    수정
                                  </Button>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                        {list.length === 0 && (
                          <tr>
                            <td colSpan="6"> 해당 데이터가 없습니다. </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <p>
                      <small>
                        물리테이블 <b>board</b>는 순장나눔방(
                        <a href="https://tens.wekoinonia.org" target="_blank">
                          https://tens.wekoinonia.org
                        </a>
                        ) , <b>board1</b>은 홈페이지(
                        <a href="https://www.wekoinonia.org" target="_blank">
                          https://www.wekoinonia.org
                        </a>
                        )입니다.
                      </small>
                    </p>
                  </div>
                </div>
                <Row>
                  <Col lg={8} className="mx-auto">
                    <PagingNav paging={paging} callback={getPage} />
                  </Col>

                  <Col lg={4} className="mx-auto">
                    {/* {selectedList.map( (item,index) => {
                        return (<span key={index}>{item} / </span>);
                        })
                    } */}
                    <InputGroup style={{ display: "none" }}>
                      <Link to={`/MybbsMasterForm/`}>
                        <Button
                          variant="primary"
                          type="button"
                          style={{ width: "8rem" }}
                        >
                          신규등록
                        </Button>
                      </Link>
                    </InputGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*.container-fluid */}
    </div>
  );
};

export default MybbsMaster;
